export default (function (theme) {
  return {
    visibility: {
      cursor: 'pointer',
      '&:hover': {
        '& svg path': {
          fill: theme.colors.neutral800
        }
      }
    }
  };
});